import _Reflect$construct from "@babel/runtime-corejs2/core-js/reflect/construct";
import _classCallCheck from "@babel/runtime-corejs2/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/createClass";
import _inherits from "@babel/runtime-corejs2/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime-corejs2/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs2/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_Reflect$construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import * as React from 'react';
import * as PropTypes from 'prop-types';
import classnames from 'classnames';
import warning from 'warning';
import { clone } from '@utiljs/clone';
import { Guid } from '@utiljs/guid';
import Step from './Step';
var timestamp = new Date().getTime(); // @ts-ignore

var g = new Guid(timestamp);

var Steps = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(Steps, _React$PureComponent);

  var _super = _createSuper(Steps);

  function Steps() {
    var _this;

    _classCallCheck(this, Steps);

    _this = _super.apply(this, arguments);

    _this.getCurrentStatus = function (active, index) {
      var status = _this.props.status;

      if (active > index + 1) {
        return 'finish';
      }

      if (active === index + 1) {
        if (status === 'error') {
          return 'error';
        }

        return 'active';
      }

      return '';
    };
    /**
     * 修正 step 数据
     */


    _this.tranStepProps = function (step, key) {
      var stepVals = {
        skey: '',
        title: '',
        desc: ''
      };

      if (typeof step === 'string') {
        stepVals.skey = key.toString();
        stepVals.title = step;
      } else {
        if (!step.hasOwnProperty('title')) {
          warning(false, '"title" 是必须的');
        }

        stepVals = clone(step);

        if (!stepVals.skey) {
          stepVals.skey = key.toString();
        }
      }

      return stepVals;
    };

    _this.handleOnChange = function (index) {
      var onChange = _this.props.onChange;

      if (onChange) {
        onChange(index);
      }
    };

    _this.renderChildStep = function () {
      var _this$props = _this.props,
          status = _this$props.status,
          children = _this$props.children,
          active = _this$props.active,
          direction = _this$props.direction;
      var stepList = React.Children.map(children, function (child, index) {
        var stepVals = _this.tranStepProps(child.props, index + 1);

        var current = _this.getCurrentStatus(active, index);

        return /*#__PURE__*/React.createElement(Step, {
          key: g.guid('step'),
          status: stepVals.status || status,
          current: current,
          skey: stepVals.skey,
          title: stepVals.title,
          desc: stepVals.desc,
          direction: direction,
          isButton: _this.isButton,
          onChange: function onChange() {
            _this.handleOnChange(index + 1);
          }
        });
      });
      return stepList;
    };

    _this.renderStepList = function () {
      var _this$props2 = _this.props,
          steps = _this$props2.steps,
          status = _this$props2.status,
          active = _this$props2.active,
          direction = _this$props2.direction,
          textPosition = _this$props2.textPosition;

      if (steps.length === 0) {
        warning(false, 'steps 属性不能为空');
      }

      var stepList = steps.map(function (step, index) {
        var current = _this.getCurrentStatus(active, index);

        var stepVals = _this.tranStepProps(step, index + 1);

        return /*#__PURE__*/React.createElement(Step, {
          key: g.guid('step'),
          skey: stepVals.skey,
          title: stepVals.title,
          desc: stepVals.desc,
          status: current === status ? status : 'wait',
          current: current,
          textPosition: textPosition,
          direction: direction,
          isButton: _this.isButton,
          onChange: function onChange() {
            _this.handleOnChange(index + 1);
          }
        });
      });
      return stepList;
    };

    return _this;
  }

  _createClass(Steps, [{
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          textPosition = _this$props3.textPosition,
          direction = _this$props3.direction,
          className = _this$props3.className,
          style = _this$props3.style,
          children = _this$props3.children;
      var stepList = children && children.length ? this.renderChildStep() : this.renderStepList();
      var ulClass = classnames({
        'roo-steps-vertical': direction === 'vertical',
        'roo-steps': direction !== 'vertical',
        'roo-steps-align': textPosition === 'right' && direction !== 'vertical',
        vertical: textPosition !== 'right' && direction !== 'vertical'
      }, className);
      return /*#__PURE__*/React.createElement("ul", {
        className: ulClass,
        style: style
      }, stepList);
    }
  }, {
    key: "isButton",
    get: function get() {
      return this.props.onChange !== undefined;
    }
  }]);

  return Steps;
}(React.PureComponent);

Steps.propTypes = {
  status: PropTypes.oneOf(['wait', 'finish', 'process', 'error']),
  steps: PropTypes.array,
  active: PropTypes.number,
  textPosition: PropTypes.string,
  direction: PropTypes.string,
  className: PropTypes.string,
  style: PropTypes.object
};
Steps.defaultProps = {
  status: 'wait',
  steps: [],
  active: 0,
  textPosition: 'bottom',
  direction: 'horizontal',
  className: '',
  style: {}
};
Steps.Step = Step;
export default Steps;